var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"footer-container"},[_c('p',{staticClass:"pull-left"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("京ICP备19045497号-1")]),_vm._v("  ©版权所有：中国老教授协会信息中心  地址：北京市海淀区清华大学学研大厦B座907室  邮编：100084")])])])
}]

export { render, staticRenderFns }